import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get, filter } from 'lodash';
import whiteBackground from '../wrapper-components/white-background';
import { Tabs } from '../elements-buttons/tab-buttons';
import PaymentsSummary from './payments-summary';
import PayoutsMain from './payouts/PayoutsMain';
import { FormattedMessage } from 'react-intl';
import TaxDetails from './taxes/TaxDetails';
import { TaxDetailsSection } from './TaxDetails';
import { StatsigContext } from '../elements-statsig-provider/statsig-context';
import { Spinner } from 'shared-components/decorators/spinner';

class PaymentsHostContainer extends Component {
  static contextType = StatsigContext;

  render () {
    const { flow, fees, isVatEnabled, isCanadaProfile } = this.props;
    // Gates the rebuilt Tax Details module; falls back to the legacy section
    // until Statsig resolves, so nothing flashes the new UI then swaps back.
    const isVatValidationEnabled = this.context?.featureGates?.vat_validation ?? false;
    const taxSection = isVatValidationEnabled ?
      // Legacy grid, which the rebuilt module does not carry itself
      <div className="col-xs-12 col-md-8 no-gutter">
        <TaxDetailsSection />
      </div>
      : <TaxDetails {...this.props}/>;
    const hasFetchedFeesAndRegions = get(fees, 'hasFetched', false);
    const feeTypes = get(fees, 'feeTypes', []);
    const federalFee = filter(feeTypes, (feeType) => { return !feeType.is_subregion; });
    const intlDataKey = isCanadaProfile ?
    'gst_hst' : get(federalFee, '[0].name', '');

    const tabs = [
      {
        label: <FormattedMessage id="hosting.payments_host_container.payouts" defaultMessage="Payouts"/>,
        link: 'account/payouts'
      },
      {
        label: <FormattedMessage id="hosting.payments_host_container.payment_methods" defaultMessage="Payment Methods"/>,
        link: 'account/methods'
      }
    ];

    if (isVatEnabled) {
      tabs.push({
        label: <FormattedMessage id="hosting.tax_details_page.taxes_tab_text" defaultMessage="Taxes"/>,
        link: 'account/taxes'
      });
    };

    return (
      <div className="PaymentsHost ps-container-fixed ps-container-lg-margin">
        <div className="ps-row">
          <div className="col-xs-12">
            <h2 className="heading">
              <FormattedMessage
                id="hosting.payments_host_container.payments_heading"
                defaultMessage="Payments"
              />
            </h2>

            <Tabs tabs={tabs} />

            {
              (!flow || 'payouts' === flow) &&
              <PayoutsMain location={this.props.location} />
            }

            {
              'methods' === flow &&
              <PaymentsSummary
                {...this.props}
                intlDataKey={intlDataKey}
                hideHeading />
            }

            {
              'taxes' === flow &&
              (hasFetchedFeesAndRegions ?
                  taxSection
                  :
                  <div className="spinner-container">
                    <Spinner additionalStyle="gray" />
                  </div>
              )
            }
          </div>
        </div>
      </div>
    );
  }
}

PaymentsHostContainer.propTypes = {
  flow: PropTypes.string,
  profile: PropTypes.object,
  location: PropTypes.object
};

export default whiteBackground(PaymentsHostContainer);
